import createComponent from '@carvana/merch-components/createComponent';

export const GoldText = createComponent('span', {
  className: 'text-brand-tertiary'
});

export const Heading = createComponent('h1', {
  className: 't-heading-sm text-text-inverse mb-lg mt-auto'
});

export const HeroWrapper = createComponent('section', {
  className: 'relative overflow-hidden bg-background-strong md:h-[250px]'
});

export const Subtitle = createComponent('p', {
  className: 't-body-sm text-text-inverse md:t-body-lg'
});

export const TextContent = createComponent('div', {
  className:
    'relative z-10 flex flex-col p-2xl h-full md:justify-center md:py-4xl md:pl-[84px] md:pr-0'
});
